/*
 * PLEASE NOTE THAT THIS FILE IS ELB SPECIFIC DUE TO IE8 SUPPORT
 */

"use strict";
import isObject from 'lodash/isObject'
import isString from 'lodash/isString'
import forceUpdateUrl from '../../../../front/utils/forceUpdateUrl'
import isIframe from '../../../../front/utils/isIframe'

/**
 * Avoid `console` errors in browsers that lack a console.
 */
(function () {
  var method, noop = function () {
    },
    methods = [
      'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
      'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
      'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
      'timeStamp', 'trace', 'warn'
    ],
    length = methods.length,
    console = (window.console = window.console || {});

  while (length--) {
    method = methods[length];

    // Only stub undefined methods.
    if (!console[method]) {
      console[method] = noop;
    }
  }
}());

/**
 * Spiral
 * @constructor
 */
var spiral = window.spiral = new function () {
  /**
   * Default ajax options.
   *
   * @type {{url: null, method: string, data: String|Object, processAnswer: Function}}
   */
  var ajaxOptions = {
    url: null,
    method: 'POST',
    data: {},
    processAnswer: function (options) {
      console.warn("You should override processAnswer method to own! Arguments", arguments);
    },
    isSuccess: true
  };

  this.processResponse = function (options, xhr) {
    const contentType = xhr.getResponseHeader("Content-Type");

    options.request = xhr;

    const isJsonResponse = contentType && contentType.includes("application/json")

    if (isJsonResponse) {
      try {
        // NOTE: for catch exception Failed to read the 'responseText'
        options.response = JSON.parse(xhr.responseText);
      } catch (exception) {
        console.error("fail to parse JSON ", JSON.stringify(xhr), exception);

        options.response = xhr.response;
      }
    } else {
      options.response = xhr.response;
    }

    if (xhr.status === 0) {
      return;
    }

    options.isSuccess = xhr.status >= 200 && xhr.status < 300

    // status > 300
    if (!options.isSuccess) {
      console.error(`Request Error, status ${xhr.status}`)
    }

    if (options.response?.action) {
     applyResponseAction(options.response.action, options)

      if(!options.response.action.hasOwnProperty('mountID')) {
        return
      }
    }

    if (xhr.status === 404) {
      applyResponseAction({ baseRedirect: options.url }, options); // TODO: hack for display error on MOP page

      return
    }

    const isBlobDownloadRequest = (options.request.responseType === "blob") && isJsonResponse

    if (isBlobDownloadRequest) {
      return readBlobJsonResponse(xhr.response)
        .then((result) => {
          let response = null

          try {
            response = JSON.parse(result)

            if (response.action) {
              applyResponseAction(response.action, options)

              options.response = null
            } else {
              options.response = response
            }
          } catch (exception) {
            console.error("fail to parse JSON in readBlobJsonResponse", JSON.stringify(xhr), exception);

            options.response = response
          }

          return options.processAnswer(options);
        })
        .catch((error) => {
          console.error(`readBlobJsonResponse error: ${error}`)
        })
    }

    return options.processAnswer(options);
  };
  /**
   * Add ability to by pass some additional ajax options.
   *
   * @param {object} request
   * @returns {*}
   */

  this.ajax = function (request) {
    request = spiral.tools.extend(ajaxOptions, request);

    var xhr = new XMLHttpRequest(),//IE7+
      upload = xhr.upload,
      that = this;

    if (request.lockProgress) {
      upload.addEventListener("progress", function (event) {
        if (event.lengthComputable) {
          request.lockProgress(event.loaded, event.total);
        }
      }, false);
    }
    xhr.onreadystatechange = function (e) {
      if (xhr.readyState == 4) {
        that.processResponse.call(that, request, xhr)

      }
    };

    if (isIframe()) {
      request.url = forceUpdateUrl(request.url)
    }

    xhr.open(request.method, request.url);

    if (request.responseType) {
      xhr.responseType = request.responseType
    }

    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    var dataToSend = '';
    if (request.data.toString().indexOf("FormData") !== -1) {//if form data
      dataToSend = request.data;
    } else {
      dataToSend = new spiral.LikeFormData(request.data, xhr);
    }
    try {
      xhr.send(dataToSend);
    } catch (e) {
      console.error("error sending trying another method");
      xhr.send(dataToSend.toString());
    }

    return xhr;
  };

  /**
   * Templator cache.
   */
  var templateCache = {};

  /**
   * Process click on select editor button
   * @param {String} template name of template
   * @param {Array} data context data
   */
  this.template = function (template, data) {
    var fn = /^[a-z0-9\-]+$/i.test(template) ? templateCache[template] = templateCache[template] || this.template(document.getElementById('js-template-' + template).innerHTML) :
      new Function("obj",
        "var p=[],print=function(){p.push.apply(p,arguments);};" +

        // Introduce the data as local variables using with(){}
        "with(obj){p.push('" +

        // Convert the template into pure JavaScript
        template
          .replace(/[\r\t\n]/g, " ")
          .split("<%").join("\t")
          .replace(/((^|%>)[^\t]*)'/g, "$1\r")
          .replace(/\t=(.*?)%>/g, "',$1,'")
          .split("\t").join("');")
          .split("%>").join("p.push('")
          .split("\r").join("\\'")
        + "');}return p.join('');"
      );

    return data ? fn(data) : fn;
  };

  /**
   * Create element from template
   * @param {String} string template
   * @returns {Node}
   */
  this.createElement = function (string) {
    var container = document.createElement('div');
    container.innerHTML = string.replace(/^\s+|\s+$/g, '');

    return container.firstChild;
  };
  /**
   * Remember hash.
   * Example: if spiral.listing was placed into a bootstrap tab and order was changed.
   */
  this.rememberHash = function () {
    if (localStorage && window.location.hash) {
      localStorage.windowLocationHash = window.location.hash;
    }
    return true;
  }
};

  /**
 * Collection of useful tools
 */
spiral.tools = {
  /**
   * Merge object1 and object2 into one object
   * @param {Object} obj1
   * @param {Object} obj2
   * @returns {Object} onj3
   */
  extend: function (obj1, obj2) {
    var obj3 = {};
    for (var attrname in obj1) {
      obj3[attrname] = obj1[attrname];
    }
    for (var attrname in obj2) {
      obj3[attrname] = obj2[attrname];
    }
    return obj3;
  },
  /**
   * Found first parent node with matched selector(s)
   * @param {Object} elem - dom node
   * @param {String|Array} selectors - selector or array of selectors
   * @returns {Object| Boolean} - node or false
   */

  closest: function (elem, selectors) {
    return $(elem).closest(selectors)[0];//IE8
  },
  /**
   * Found first parent node with matched className(s).
   * TODO Why this? Because old IE....
   * TODO It's not good, because it's a copy of closest @see closest. Refactor
   * @param {Object} elem - dom node
   * @param {String|Array} className - className or array of classNames
   * @returns {Object| Boolean} - node or false
   */

  closestByClassName: function (elem, className) {
    className = (typeof className === 'string') ? [className] : className;
    while (elem && elem.parentNode) {
      for (var key = 0; key < className.length; key++) {
        var reg = new RegExp("(\\s|^)" + className[key] + "(\\s|$)");
        if (elem.className.match(reg)) {
          return elem;
        }
      }
      elem = elem.parentNode;
    }
    return false;
  },

  isHTMLElement: function(o){//used in patched spiral.InstancesController.js IE8 SPECIFIC
    return (
      typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
        o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName==="string"
    );
  }
};

/**
 * Spiral Events system.
 * @constructs spiral.Events
 */
spiral.Events = function () {
  this._actions = {};
};
/**
 * Add action
 * @param {String} action
 * @param {Function} func
 * @lend spiral.events
 */
spiral.Events.prototype.registerAction = function (action, func) {
  if (!this._actions.hasOwnProperty(action)) {
    this._actions[action] = [];
  }
  this._actions[action].push(func);
}

/**
 * Perform action
 * @param {String} action
 * @param {Object} [actionParams] object with all action data from server
 * @param {Object} [options] ajax options
 */
spiral.Events.prototype.performAction = function (action, actionParams, options) {
  if (this._actions.hasOwnProperty(action)) {
    for (let n = 0; n < this._actions[action].length; n++) {
      this._actions[action][n](actionParams, options);
    }
  }
};


spiral.actions = new spiral.Events();
spiral.events = new spiral.Events();

spiral.actions.registerAction("redirect", function (action) {
  if (Object.prototype.toString.call(action) === "[object String]") {
    window.location.pathname = action;
  } else {
    window.location.pathname = action.href || action.url;
  }
});

spiral.actions.registerAction("baseRedirect", function (action) {
  if (Object.prototype.toString.call(action) === "[object String]") {
    window.location.href = action;
  } else {
    window.location.href = action.href || action.url;
  }
});


spiral.actions.registerAction('reload', function () {
  location.reload();
});

spiral.actions.registerAction('refresh', function () {
  spiral.actions.performAction('reload');
});

spiral.actions.registerAction('close', function () {
  window.close();
});

spiral.actions.registerAction('none', function () {
  console.log('call action none')
});

spiral.actions.registerAction('mountID', function (id, options) {
  var form = spiral.instancesController.getInstance("form", options.context);
  form.options.url = options.context.action = options.url + id;
});

/**
 * Infinity scrolling calculations
 * @param {Node|String|Window} internalContainer
 * @param {Node|String|Window} externalContainer
 * @param {Number} distance
 * @param {Function} callback
 * @constructor
 */
spiral.InfiniteScroll = function (internalContainer, externalContainer, distance, callback) {
  this.isEnabled = null;
  this.internalContainer = internalContainer;
  this.externalContainer = externalContainer;

  this.distance = (distance) ? distance : 300;
  this.callback = callback;
  this.checkScrollBinded = this.checkScroll.bind(this);
  this.enable();
};

/**
 * Enable scrolling
 */
spiral.InfiniteScroll.prototype.enable = function () {
  if (this.isEnabled === null) {
    this.externalContainer.addEventListener("scroll", this.checkScrollBinded, false);
  }
  this.isEnabled = true;


};
/**
 * Disable scrolling
 * @param {boolean}  [isPermanent]
 */
spiral.InfiniteScroll.prototype.disable = function (isPermanent) {
  if (isPermanent) {
    this.externalContainer.removeEventListener("scroll", this.checkScrollBinded, false);
  }
  this.isEnabled = false;

};

/**
 * Check scroll
 */
spiral.InfiniteScroll.prototype.checkScroll = function () {
  if (!this.isEnabled) {
    return;
  }
  var isShouldLoadMore = (this.externalContainer === window) ? this.checkScrollWindow() : this.checkScrollExternalContainer();
  if (!isShouldLoadMore) {
    isShouldLoadMore = (this.externalContainer === window) ? this.checkPositionWindow() : this.checkPositionExternalContainer();
  }

  if (isShouldLoadMore) {
    this.callback();
  }


};

var supportPageOffset = window.pageXOffset !== undefined;
var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

/**
 * Check scroll of window
 * @returns {boolean}
 */
spiral.InfiniteScroll.prototype.checkScrollWindow = function () {
  var offset = supportPageOffset ? window.pageYOffset :
    isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  return (offset >= (document.body.clientHeight - $(window).height() - this.distance));
};

/**
 * Check scroll
 * @returns {boolean}
 */
spiral.InfiniteScroll.prototype.checkScrollExternalContainer = function () {
  //TODO тут общий случай когда инфинити лоадер идет в внутри какой либо ноды. Закодить когда будет надо
  debugger;
};

/**
 * Check free space in container. If space available we should fill it
 * @returns {boolean}
 */
spiral.InfiniteScroll.prototype.checkPositionWindow = function () {
  return (window.outerHeight >= this.internalContainer.getBoundingClientRect().bottom);
};

/**
 * Check free space in container. If space available we should fill it
 * @returns {boolean}
 */
spiral.InfiniteScroll.prototype.checkExternalContainer = function () {
//TODO тут общий случай когда инфинити лоадер идет в внутри какой либо ноды. Закодить когда будет надо
};


/**
 * Show confirm message
 * @param {String} className class name to bind
 * @constructor
 */
function SpiralConfirm(className) {
  var that = this;
  $(document).on('click', '.' + className, function(e){//ELB supports IE8
    that.processConfirm.call(that, e)
  });
}
/**
 * Perform process when user click to button with confirm
 * @param {Event} e mouse event
 */
SpiralConfirm.prototype.processConfirm = function (e) {
  e.preventDefault();
  var text = e.currentTarget.getAttribute("data-confirm");
  //Perform callbackFailure when user click to button with cancel
  if (!window.confirm(text)) {
    var callbackFailure = e.currentTarget.getAttribute("data-callback-failure");
    if (
      callbackFailure &&
      typeof (window[callbackFailure]) === 'function'
      ) {
      window[callbackFailure](e);
    }
  }
  else {
    var callbackSuccess = e.currentTarget.getAttribute("data-callback");
    //Perform ajax call when user click to button with confirm
      spiral.ajax({
        url: $(e.currentTarget).attr('href'),
        processAnswer: function (result) {
            if (result.isSuccess) {
              if (
                callbackSuccess &&
                typeof (window[callbackSuccess]) === 'function'
                ) {
                window[callbackSuccess](e);
              }
              else {
                alert(result.response)
              }
            }
        },
    });
    
  }
};

new SpiralConfirm("js-spiral-confirm");

/**
 * This object like form data
 * @param obj
 * @param xhr
 */
spiral.LikeFormData = function (obj, xhr) {
  this.data = obj;
  this.boundary = "SpiralAjax-" + Math.random().toString().substr(2);
  xhr.setRequestHeader("content-type", "multipart/form-data; charset=utf-8; boundary=" + this.boundary);
};
/**
 * Append data to storage
 * @param key
 * @param val
 */
spiral.LikeFormData.prototype.append = function (key, val) {
  this.data[key] = val;
};

/**
 * convert to object
 */
spiral.LikeFormData.prototype.toString = function () {
  var retString = "";
  var boundary = this.boundary;
  var iterate = function (data, partOfKey) {
    for (var key in data) {
      if (typeof data[key] === "object") {
        iterate(data[key], ((partOfKey.length === 0) ? key : (partOfKey + "[" + key + "]")));
      } else {
        retString += "--" + boundary
          + "\r\nContent-Disposition: form-data; name=" + ((partOfKey.length === 0) ? key : (partOfKey + "[" + key + "]"))
          + "\r\n\r\n" + data[key] + "\r\n";
      }
    }
  };
  iterate(this.data, "");

  retString += "--" + this.boundary + "--\r\n";
  return retString;
};

function applyResponseAction (action, options) {
  const actionIsString = isString(action)
  const actionIsObject = isObject(action)

  if (actionIsString) { //action:"refresh",
    spiral.actions.performAction(action);
  }

  if (actionIsObject) {
    if (action.method) {
      setTimeout(function(){
        spiral.actions.performAction(action.method, action, options);
      }, action.delay || 0);
    } else {
      const actionKeys = Object.keys(action)

      if (actionKeys.length) {
        actionKeys.forEach((key) => {
          spiral.actions.performAction(key, action[key], options);
        })
      } else {
        console.error("Action from server. Object have to keys . ", action);
      }
    }
  }

  if (!actionIsString && !actionIsObject) {
    console.error("Action from server.Something wrong. ", action);
  }
}

function readBlobJsonResponse (response) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader()

    if (!response) {
      throw new Error(`${response} is required prop of readBlobJsonResponse`)
    }

    fr.onload = (event) => {
      try {
        let result
        if (window.TextDecoder) {
          result = new TextDecoder('utf-8').decode(new Uint8Array(event.target.result))
        } else {
          result = String.fromCharCode.apply(null, new Uint8Array(event.target.result))
        }

        return resolve(result)
      } catch (error) {
        console.error(`parse response: ${response} of readBlobJsonResponse is broken`)
        return reject(JSON.stringify(error)) // NOTE return consistent json type
      }
    }
    fr.readAsArrayBuffer(response)
  })
}
